module.exports = __webpack_public_path__ + "media/images/result_test-e074ff18.png";